import React from "react";
import { SelectPicker } from "rsuite";

interface Props {
  data: any;
  label?: string;
  onChange?: any;
  value?: any;
  onClean?: any;
  isValidate?: boolean;
  displayLabel?: boolean;
  placeholder?: string;
  defaultValue?: any;
  disabled?: boolean;
  onSelect?: any;
  searchable?: boolean;
  onSearch?: any;
  customNoFoundMsg?: string;
  renderMenuItem?: (label: React.ReactNode, item: any) => React.ReactNode;
}
export const EPSelectPicker: React.FC<Props> = ({
  defaultValue,
  disabled,
  isValidate,
  data,
  label,
  onChange,
  value,
  onClean,
  displayLabel,
  placeholder,
  onSelect,
  searchable,
  onSearch,
  customNoFoundMsg,
  renderMenuItem,
}) => {
  let dataList: any;
  if (label === "Designation") {
    dataList =
      data &&
      data.map((item: any) => ({
        label: item.DesignationName,
        value: item.DesignationId,
      }));
  } else if (label === "Project") {
    dataList =
      data &&
      data?.map((item: any) => ({
        label: item.ProjectName,
        value: item.ProjectId,
      }));
  } else if (label === "Existing Employee *") {
    dataList =
      data &&
      data?.map((item: any) => ({
        label: item.FirstName,
        value: item.EmployeeId,
      }));
  } else if (label === "Technology") {
    dataList =
      data &&
      data.map((item: any) => ({
        label: item.Name,
        value: item.Id,
      }));
  } else if (label === "InterviewerList") {
    dataList =
      data &&
      data.map((item: any) => ({
        label: item.InterviewerName,
        value: item.InterviewerIdList,
      }));
  } else if (label === "Round") {
    dataList =
      data &&
      data.map((item: any) => ({
        label: item.RoundName,
        value: item.RoundId,
      }));
  } else if (label === "FrequencyFinalization") {
    dataList =
      data &&
      data.map((item: any) => ({
        label: item.FrequencyFinalizeCandidate,
        value: item.FrequencyFinalizeCandidate,
      }));
  } else if (label === "CurrentStatusOfCallingCandidate") {
    dataList =
      data &&
      data.map((item: any) => ({
        label: item.CallingCandidateStatus,
        value: item.CallingCandidateStatusId,
      }));
  } else if (label === "ReasonOfChangeForCallingCandidate") {
    dataList =
      data &&
      data.map((item: any) => ({
        label: item.CandidateReasonForChange,
        value: item.CandidateReasonForChangeId,
      }));
  } else if (label === "Skills") {
    dataList =
      data &&
      data.map((item: any) => ({
        label: item.TechnologyName,
        value: item.TechnologyID,
      }));
  } else if (label === "JD Template") {
    dataList =
      data &&
      data.map((item: any) => ({
        label: item.TemplateName,
        value: item.templateId,
      }));
  } else if (label === "Priority") {
    dataList =
      data &&
      data.map((item: any) => ({
        label: item.Priority,
        value: item.PriorityId,
      }));
  } else if (label === "RaisedBy") {
    dataList =
      data &&
      data.map((item: any) => ({
        label: item.Role,
        value: item.RoleId,
      }));
  } else if (label === "EditJD") {
    dataList =
      data &&
      data.map((item: any) => ({
        label: item.Name,
        value: item.Id,
      }));
  } else if (label === "Type") {
    dataList =
      data &&
      data.map((item: any) => ({
        label: item.Type,
        value: item.TypeId,
      }));
  } else if (label === "Importance") {
    dataList =
      data &&
      data.map((item: any) => ({
        label: item.Importance,
        value: item.ImportanceId,
      }));
  } else if (label === "Status") {
    dataList =
      data &&
      data?.map((item: any) => ({
        label: item.StatusName,
        value: item.StatusId,
      }));
  } else if (label === "Recruiter") {
    dataList =
      data &&
      data.map((item: any) => ({
        label: `${item.FirstName}${item.LastName ? ` ${item.LastName}` : ""}`,
        value: item.EmployeeId,
      }));
  } else if (label === "DegreeList") {
    dataList =
      data &&
      data.map((item: any) => ({
        label: item.DegreeName,
        value: item.Id,
      }));
  } else if (label === "Schedule type") {
    dataList =
      data &&
      data.map((item: any) => ({
        label: item?.ScheduleType,
        value: item?.ScheduleTypeId,
      }));
  } else if (label === "Round type") {
    dataList =
      data &&
      data.map((item: any) => ({
        label: item.RoundName,
        value: item.RoundId,
      }));
  } else if (label === "Request Mapping") {
    dataList =
      data &&
      data.map((item: any) => ({
        label: item,
        value: item,
      }));
  } else if (label === "OverAllAssessment") {
    dataList =
      data &&
      data.map((item: any) => ({
        label: item.StatusName,
        value: item.StatusId,
      }));
  } else if (label === "RejectReasons") {
    dataList =
      data &&
      data.map((item: any) => ({
        label: item.Rejected,
        value: item.RejectedId,
      }));
  } else if (label === "Sources") {
    dataList =
      data &&
      data.map((item: any) => ({
        label: item.SourceName,
        value: item.SourceId,
        id: item.SourceId,
      }));
  } else if (label === "Interviews") {
    dataList =
      data &&
      data.map((item: any) => ({
        label: item.Interviews,
        value: item.InterviewsId,
      }));
  } else if (label === "ScheduleStatus") {
    dataList =
      data &&
      data.map((item: any) => ({
        label: item.StatusName,
        value: item.StatusId,
      }));
  } else if (label === "ScheduleCancelReason") {
    dataList =
      data &&
      data.map((item: any) => ({
        label: item.GroupDetailName,
        value: item.GroupDetailId,
      }));
  } else if (label === "Decline Reason") {
    dataList =
      data &&
      data.map((item: any) => ({
        label: item.DropoutReason,
        value: item.DropoutReasonId,
      }));
  } else if (label === "StatusList") {
    dataList =
      data &&
      data.map((item: any) => ({
        label: item.StatusName,
        value: item.StatusId,
      }));
  } else if (label === "ApplicationList") {
    dataList =
      data &&
      data?.map((item: any) => ({
        label: item.Applications,
        value: item.ApplicationsId,
      }));
  } else if (label === "RoleList" || label === "User Role") {
    dataList =
      data &&
      data?.map((item: any) => ({
        label: item.PageName,
        value: item.RoleId,
        IsRecruiter: item.IsRecruiter,
        IsSystemAdmin: item.IsSystemAdmin,
      }));
  } else if (label === "CurrentState") {
    dataList = data?.map((item: any) => ({
      label: item?.name,
      value: item?.name,
      countryCode: item?.countryCode,
      stateCode: item?.isoCode,
      SelectType: label,
    }));
  } else if (label === "CurrentCountry") {
    dataList = data?.map((item: any) => ({
      label: item?.name,
      value: item?.name,
      code: item?.isoCode,
      SelectType: label,
    }));
  } else if (label === "CurrentLocation") {
    dataList = data?.map((item: any) => ({
      label: item?.name,
      value: item?.name,
      SelectType: label,
    }));
  } else if (label === "RequirementDetail") {
    dataList = data?.map((item: any) => ({
      label: `${item?.TechnologyName} - ${item?.RequirementTitle}(${item?.RequirementId})`,
      value: item?.RequirementId,
      SelectType: label,
    }));
  } else if (label === "Event") {
    dataList = data?.map((item: any) => ({
      label: item?.Name,
      value: item?.Id,
      DefaultRecipients: item?.DefaultRecipients,
      ActualToRecipients: item?.ActualToRecipients,
      ActualCCRecipients: item?.ActualCCRecipients,
    }));
  } else if (label === "Cron Configuration") {
    dataList = data?.map((item: any) => ({
      label: item?.CronJobName,
      value: item?.Id,
    }));
  } else if (label === "CandidateName") {
    dataList = data?.map((item: any) => ({
      label: item.FullName,
      value: item.CandidateId,
    }));
  } else if (label === "pageList") {
    dataList = data?.map((item: any) => ({
      label: item.Page.PageName,
      value: item.Page.PageId,
    }));
  } else if (label === "Preferred Plan") {
    dataList = data?.map((item: any) => ({
      label: `${item?.plan_name} ${item?.is_trial_plan ? "Plan" : ` - ${item?.plan_type}`}`,
      value: item?.plan_id,
    }));
  } else if (
    label === "PrimaryInterviewer" ||
    label === "SecondaryInterviewer"
  ) {
    dataList =
      data &&
      data?.map((item: any) => ({
        label: `${item.FirstName} ${item.LastName ? item.LastName : ""}`,
        value: item.EmployeeId,
      }));
  } else if (label === "LessThan" || label === "BetterThan") {
    dataList =
      data &&
      data?.map((item: any) => ({
        label: `${item.FirstName} ${item.LastName ? item.LastName : ""}`,
        value: item.EmployeeId,
      }));
  } else if (label === "Currency") {
    dataList =
      data &&
      data?.map((item: any) => ({
        label: `${item.code}`,
        value: item.code,
      }));
  } else if (label === "ResumeStatus") {
    dataList =
      data &&
      data.map((item: any) => ({
        label: item.label,
        value: item.value,
      }));
  } else if (label === "ComplexityLevel") {
    dataList =
      data &&
      data.map((item: any) => ({
        label: item.label,
        value: item.value,
        description: item.description,
      }));
  } else {
    dataList =
      data &&
      data.map((item: any) => ({
        label: item,
        value: item,
      }));
  }
  return (
    <SelectPicker
      disabled={disabled}
      defaultValue={defaultValue}
      value={value}
      label={displayLabel ? label : null}
      data={dataList}
      onSelect={onSelect}
      onChange={(value) => {
        onChange(value);
      }}
      onSearch={onSearch}
      placeholder={placeholder}
      onClean={onClean}
      renderMenu={(menu) => {
        if (dataList.length === 0 && customNoFoundMsg) {
          return <div className="rs-picker-none">{customNoFoundMsg}</div>;
        }
        return menu;
      }}
      renderMenuItem={renderMenuItem || undefined}
      className={!value && isValidate ? "border border-danger" : ""}
      searchable={searchable}
    />
  );
};
